

































































import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import { useI18n } from '~/compositions/i18n'
import { QuickSearchCategory } from '~/models/quick-search/types'
import { getStaticUrl } from '~/utils/static'

export default defineComponent({
  props: {
    category: {
      type: Object as PropType<QuickSearchCategory>,
      required: true
    },
    children: {
      type: Array as PropType<QuickSearchCategory[]>,
      default: () => []
    }
  },
  setup(props) {
    const { children, category } = toRefs(props)
    const { t } = useI18n()

    const hasChildren = computed(() => children.value.length)

    const imageUrl = computed(() =>
      getStaticUrl(
        `/nuxt-static/img/quick-search/categories/${category.value.id}.png`
      )
    )
    const linkClasses = [
      'tw-text-grey-800',
      'hover:tw-text-grey-900',
      'hover:tw-underline'
    ]

    function getTitleForCategory(c: any) {
      return `${t('show')} ${c.formattedClassifiedCount} ${t('classifieds')}`
    }

    return { imageUrl, hasChildren, linkClasses, getTitleForCategory }
  }
})
